import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { GroceryPreferences } from '@hungryroot/app-mhr';
import { ToastContainer } from '@hungryroot/components-toast';
import { client } from '../../../components/rest/react-query';
import FoodProfile from './food_profile/FoodProfile';
import { tag } from './generic/global_state/reducers';
import configureStore from './utils/configure_store';
import { renderApp } from './utils/utils';

const store = configureStore(tag);

renderApp(
  <QueryClientProvider client={client}>
    <Provider store={store}>
      <Router>
        <FoodProfile />
        <GroceryPreferences />
        <ToastContainer position="bottom-center" duration={3000} />
      </Router>
    </Provider>
  </QueryClientProvider>,
  'fp-top-section'
);
